module.exports = __webpack_public_path__ + "img/orcaloop3c.1073f350.gif";